import script from "./NavigationBar.vue?vue&type=script&setup=true&lang=js"
export * from "./NavigationBar.vue?vue&type=script&setup=true&lang=js"

import "./NavigationBar.vue?vue&type=style&index=0&id=97772054&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-97772054"]])

export default __exports__